import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import { Exec } from '../components/widgets/Exec';

export default function ExecPage() {
  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header title="אופרטיבי" />
        <main className="flex-1 overflow-y-auto p-6">
          <Exec />
        </main>
      </div>
    </div>
  );
}
